<template>
  <main id="admin-content">
    <Header :collapsed="false"></Header>
    <div class="body-content sessions-container">
      <div class="page-controls__control-row">
        <div class="page-controls__filter">
          <div class="dropdown-filter select-wrapper">
            <span class="dropdown-filter__select-label">Por página</span>
            <b-form-select v-on:change="resetPagination" plain class="limit-selector" v-model="recordings_pagination.limit" :options="recordings_pagination_options"></b-form-select>
          </div>
        </div>
      </div>
      <div class="full-width-content--small" v-show="!loading">
        <div v-if="!recordings.length" class="no-content no-results">
          <span class="no-content-title">No encontramos grabaciones sin procesar.</span>
        </div>
        <table v-else class=content-table reuse>
          <tbody>
            <tr class="content-table__header content-table__header--shadow">
              <th class="medium-8">Nombre de la sesión/nombres de la grabación</th>
              <th class="medium-4">Fecha</th>
              <th class="medium-4">Tipo</th>
              <th class="medium-4">Id de la grabación</th>
              <th class="medium-4">Estado</th>
            </tr>
            <tr v-for="recording in recordings" v-bind:key="recording.id" class="element-list-row">
              <td class="break-word content-table__emphasis">
                {{ recording.sessionName }}/{{ recording.mediaName }}
              </td>
              <td class="date">
                {{ recording.startTime | moment("D/M/YY HH:mm") }}
              </td>
              <td class="break-word">
                {{ recording.originSystem }}
              </td>
              <td class="break-word">
                {{ recording.externalSourceId }}
              </td>
              <td class="break-word">
                <span v-if="recording.recordingUrl">
                  Sin procesar
                </span>
                <span v-if="!recording.recordingUrl">
                  Procesando...
                </span>
              </td>
              <td class="item-controls" style="text-align: unset;">
                <button v-if="recording.recordingUrl" class="button secondary short button-action-reuse-session" @click="reProcess(recording)">Reprocesar</button>
                <button v-if="!recording.recordingUrl" class="button secondary short button-action-reuse-session" style="background: transparent;color: transparent;cursor: default;">Reprocesar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <footer v-if="recordings_pagination.limit < recordings_total" class="page-footer session-list-pagination">
      <b-pagination
        v-model="recordings_pagination_current"
        :total-rows="recordings_total"
        :per-page="recordings_pagination.limit"
        align="center"
        aria-controls="report-content-table"
      ></b-pagination>
    </footer>
    <vue-confirm-dialog class="pv-confirm"></vue-confirm-dialog>
  </main>
</template>

<script>
import jwtMixin from '../../mixins/jwtMixin'
import utilitiesMixin from '../../mixins/utilitiesMixin'

import Header from '@/components/Admin/Header/Header'

export default {
  name: 'RecordingsReprocess',
  components: {Header},
  mixins: [jwtMixin, utilitiesMixin],
  created () {
    this.initRecordings()
  },
  data () {
    return {
      loading: false,
      recordings: [],
      recordings_total: 0,
      recordings_pagination_current: 1,
      recordings_pagination: {
        limit: this.defaultPagination(),
        offset: 0
      },
      recordings_pagination_options: this.paginationOptions()
    }
  },
  watch: {
    recordings_pagination_current: {
      handler: function (value) {
        // EAL: se establece la paginación acorde a la página activada
        this.recordings_pagination.offset = this.recordings_pagination.limit * (this.recordings_pagination_current - 1)
        this.initRecordings()
      }
    }
  },
  methods: {
    initRecordings () {
      this.loading = true
      let vueComponent = this
      this.recordings = []
      this.recordings_total = 0
      let filterParams = {
        limit: this.recordings_pagination.limit,
        offset: this.recordings_pagination.offset
      }

      filterParams.endTime = window.moment.utc(new Date(), 'MM-DD-YYYY').format('YYYY-MM-DD[T]HH:mm:ss[Z]')
      window.axios.get('recordings/processing-status', {params: filterParams}).then((response) => {
        this.recordings_total = response.data.size
        response.data.results.forEach(function (recording) {
          vueComponent.recordings.push(recording)
        })
        this.loading = false
      })
    },
    reProcess (recording) {
      recording.recordingUrl = null
      let recordingParam = {...recording}
      this.filterProperties(recordingParam)
      window.axios.put('recordings/' + recordingParam.id, recordingParam)
    },
    resetPagination () {
      // EAL: Si no estaba en la página inicial se cambia a la primera. El cambio lanza la recarga del listado
      if (this.recordings_pagination_current !== 1) {
        this.recordings_pagination_current = 1
      } else {
        this.initRecordings()
      }
    },
    filterProperties (obj) {
      Object.keys(obj).forEach(key => {
        if (key !== 'id' && key !== 'published' && key !== 'recordingUrl') {
          delete obj[key]
        }
      })
      return obj
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/RecordingsReprocess.vue